let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kpDDc")).then(() => parcelRequire('a8CW2'));